import { curry } from "lodash";

export const getPersonalization = (state: PersonalizationRootState) => state.personalization;
export const getPersonalizationByKey =
    <TData>(key: string) =>
    (state: PersonalizationRootState) =>
        getPersonalization(state)?.[key] as TData;

export const isPersonalizationDataLoaded = curry((key: string, state: PersonalizationRootState) =>
    getPersonalization(state)?.hasOwnProperty(key)
);
